export default __webpack_public_path__ + "static/media/logo_yellow_cropped.be68c6a4.png";